export default "__VITE_ASSET__CuptW$iK__"